var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassignCrystalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#DA1E28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_13991)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57195 8.39344L8.2603 4L11.1616 7.26067L10.2445 11.6843C10.5119 11.2885 10.8311 10.9305 11.1924 10.6201C11.1813 10.59 11.17 10.559 11.1586 10.5271L12.2431 8.71692L12.901 9.63255C13.4536 9.43873 14.0478 9.33333 14.6667 9.33333C17.6122 9.33333 20 11.7211 20 14.6667C20 17.6122 17.6122 20 14.6667 20C13.7526 20 12.8923 19.7701 12.1404 19.3649L11.9912 20H10.3863L9.71313 19.2393C9.74332 19.0503 9.81742 18.8459 9.89477 18.6325C9.95372 18.4698 10.0146 18.302 10.0593 18.1318H10.6122C10.3984 17.8819 10.2073 17.612 10.0422 17.3252H5.03674C3.71105 16.6539 3.62274 14.7378 4.96874 14.1162L4.97599 14.1155H9.36147C9.38007 13.9343 9.40774 13.7558 9.44401 13.5805H8.24648L7.89891 10.9113L9.98796 7.18602L8.41462 5.28474L9.18836 7.10886L7.50255 9.78102L5.34554 9.0229L7.1638 10.8985L7.17657 13.5805H5.5717L4.57195 8.39344ZM11.4988 18.9577L11.5 18.9858L11.5075 18.9641L11.4988 18.9577ZM6.08359 18.131L6.64161 20H9.3164L9.62173 18.1358L8.77449 18.1258L8.38154 19.7686L7.80632 18.1372L6.08359 18.131ZM19.3333 14.6667C19.3333 17.244 17.244 19.3333 14.6667 19.3333C12.0893 19.3333 10 17.244 10 14.6667C10 12.0893 12.0893 10 14.6667 10C17.244 10 19.3333 12.0893 19.3333 14.6667ZM12 13.3333C11.6318 13.3333 11.3333 13.6318 11.3333 14V15.3333C11.3333 15.7015 11.6318 16 12 16H17.3333C17.7015 16 18 15.7015 18 15.3333V14C18 13.6318 17.7015 13.3333 17.3333 13.3333H12Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_13991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "current",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignCrystalActive);
export default __webpack_public_path__ + "static/media/UnassignCrystalActive.e6c11a6466f87ee25a11d1b2e2e641ec.svg";
export { ForwardRef as ReactComponent };